import { render, staticRenderFns } from "./traffic.vue?vue&type=template&id=07f550ed&scoped=true&"
import script from "./traffic.vue?vue&type=script&lang=js&"
export * from "./traffic.vue?vue&type=script&lang=js&"
import style0 from "./traffic.vue?vue&type=style&index=0&id=07f550ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f550ed",
  null
  
)

export default component.exports